import React, { FC } from 'react';
// import { useTranslation } from 'react-i18next';
// import MisValesAhorroService from '../../services/MisValesAhorroService';
// import useAPIError from '../../hooks/useAPIError';
// import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/AppContext';
import ValeComponentActivableCanjeable from './ValeComponentActivableCanjeable';
import IconX from '../../Icons/IconX';
import { HostProvider } from '../../utils/HostProvider';

type Props = {
  vale: {
    tipoLista: number;
    numOferta: string;
    fechaIniVigencia: any;
    fechaFinVigencia: string;
    fechaFinCanjeoDTO: string;
    fechaFinActivacion: string;
    fechaFinCanjeoPromo: string;
    visualizar: boolean;
    activable: boolean;
    gupoInternoVisualizar: string;
    grupoInternoActivacion: string;
    valeEAN: string;
    exclusividad: boolean;
    entregada: boolean;
    canjeada: boolean;
    activada: boolean;
    idioma: string;
    textoReclamo: string;
    textoTitulo: string;
    textoDescripcion1: string;
    textoDescripcion2: string;
    canalActivacion: string;
    canales: object;
    fechaActivacion: string;
    tipoVale: string;
    scoring: number;
    codImpacto: number;
    planAdhesion: number;
    denominacionPlanAdhesion: string;
    soportePostal: number;
    denominacionSoportePostal: string;
    valeDestacado: string;
    estructurasComerciales: object;
    tienda: string;
    fechaCanjeo: any;
    horaCanjeo: any;
    locale: string;
    preferencia: string;
    fechaInicioCanjeo: string;
    showValeEntrega: boolean;
    tipoReclamo: string;
    canalesVisualizacion: object;
    showPopup: boolean;
    masivo: boolean;
    numSecuencia?: string;
    fechaEmisionValeDigitalizado?: string;
    cantidadMinimaReclamo?: string;
  };
  t: (key: string) => string;
  // index: number;
  // tipo: string;
  // fila: number;
  // cagarVales: () => void;
};
const ValeInfoMasivo: FC<Props> = ({ vale, t }) => {
  const isEroski = HostProvider.isEroski();
  const oferta = vale.textoReclamo;
  const unidad = vale.tipoReclamo;
  const dataApp = useAppStore();
  // const { t } = useTranslation();
  const CUPON_CANJEADO = 7;
  const CUPON_MASIVO_NO_ACTIVADO = 5;
  const CUPON_MASIVO_ACTIVADO = 6;
  const isDestacado = (vale.valeDestacado &&
    vale.valeDestacado === '1') as boolean;
  const isPromocion = vale.tipoLista === 4 && !vale.exclusividad;
  const isCanjeado = (vale.tipoLista === CUPON_CANJEADO) as boolean;
  const isActivado = (vale.tipoLista === CUPON_MASIVO_ACTIVADO) as boolean;
  const isNoActivado = (vale.tipoLista === CUPON_MASIVO_NO_ACTIVADO) as boolean;
  let clasesBloqueValeValor = 'bloque-vale-content__offer';
  if (!isEroski && isDestacado) {
    if (isCanjeado) {
      clasesBloqueValeValor =
        'bloque-vale-content__offer bloque-vale-content__offer--destacado-canjeado';
    } else {
      clasesBloqueValeValor =
        'bloque-vale-content__offer bloque-vale-content__offer--destacado';
    }
  }
  let clasesBloqueValeBasico = '';
  if (!isDestacado && (isActivado || (isEroski && isNoActivado))) {
    clasesBloqueValeBasico = ' bloque-vale__basico';
  } else if (!isDestacado && isCanjeado) {
    clasesBloqueValeBasico =
      ' bloque-vale__basico bloque-vale bloque-vale-container__canjeado';
  } else if (isCanjeado) {
    clasesBloqueValeBasico = ' bloque-vale bloque-vale-container__canjeado';
  }
  const claseContainerVale =
    (isDestacado || isPromocion) && !isEroski
      ? 'bloque-vale-container_destacado'
      : 'bloque-vale-container';

  return (
    <div
      id={`valeinfo-${vale.valeEAN}-${vale.numOferta}-${vale.tipoLista}`}
      className="detalle-container detalle-container--masivo no-active"
    >
      <div className={`bloque-vale__detalle-visible ${clasesBloqueValeBasico}`}>
        <span className="icon icon-medium bloque-vale__close">
          <IconX classCss="" />
        </span>
        <div className={claseContainerVale}>
          {vale.valeDestacado && vale.valeDestacado === '1' ? (
            <div
              className={`etiqueta__destacado${
                // eslint-disable-next-line no-nested-ternary
                HostProvider.isCaprabo()
                  ? vale.canjeada
                    ? '_caprabo-canjeado'
                    : '_caprabo'
                  : vale.canjeada
                  ? '-canjeado'
                  : ''
              }
                    }`}
            >
              {t('vales.destacado').toUpperCase()}
            </div>
          ) : (
            ''
          )}
          <div
            className={`divider divider__img--v ${
              isDestacado && isEroski ? '' : ' display-none'
            }`}
          />
          <div className="bloque-vale-content">
            <div className="bloque-vale-content__top">
              <span className="bloque-vale-content__top-activation">
                <ValeComponentActivableCanjeable vale={vale} />
              </span>
              {vale.cantidadMinimaReclamo && (
                <span className="bloque-vale-content__top-conditions">
                  {t('vales.masivos.compra-minima')}
                  <strong>{` ${vale.cantidadMinimaReclamo} €
              `}</strong>
                </span>
              )}
            </div>
            <div className={`${clasesBloqueValeValor}`}>
              <span className="bloque-vale-content__offer-image">
                {/* import cesta from '../../assets/images/cesta-eroski.svg';
                 <img src={cesta} alt="cesta" /> */}
              </span>
              {(() => {
                if (
                  vale.textoReclamo &&
                  vale.textoReclamo.toUpperCase() === 'GRATIS'
                ) {
                  return (
                    <>
                      <span className="bloque-vale__num ">
                        {t('vales.gratis').toUpperCase()}
                      </span>
                    </>
                  );
                }
                if (dataApp.lang === 'eu' && unidad === '%') {
                  return (
                    <>
                      <span className="bloque-vale-content__offer-num">
                        <span>{unidad}</span>
                        {oferta}
                      </span>
                    </>
                  );
                }
                return (
                  <>
                    <span className="bloque-vale-content__offer-num">
                      {oferta}
                      <span>{unidad}</span>
                    </span>
                  </>
                );
              })()}
              {vale.textoReclamo &&
                vale.textoReclamo.toUpperCase() !== 'GRATIS' && (
                  <>
                    <p className="bloque-vale-content__offer-titulo">
                      {t('vales.masivos.descuento')}
                    </p>
                  </>
                )}
              <span className="bloque-vale-content__offer-conditions">
                {vale.textoDescripcion1}
              </span>
            </div>
          </div>
        </div>

        <div className="bloque-vale__info">
          <div className="bloque-vale__info-text bloque-vale__info-text--desktop">
            {vale.textoDescripcion1} {vale.textoDescripcion2}
          </div>
          <div className="bloque-vale__info-actions">
            {vale.tipoLista === CUPON_MASIVO_NO_ACTIVADO && (
              <>
                <button
                  type="button"
                  className="btn btn-default activate-button"
                >
                  {t('vales.activarVale')}
                </button>
              </>
            )}
            <div className="bloque-vale__info-text bloque-vale__info-text--mobile">
              <p>
                {vale.textoDescripcion1} {vale.textoDescripcion2}
              </p>
            </div>
            <div className="legal-conditions">
              <a
                className="legal-conditions icon-link u-align-items-baseline"
                href="#legal-conditions"
                rel="noopener noreferrer"
              >
                <span className="u-font-small">
                  {isEroski
                    ? t('vales.condiciones-legales-titulo')
                    : t('caprabo.cupones.condiciones-legales-titulo')}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValeInfoMasivo;
